export const environment = {
  name: 'prod',
  region: 'NA',
  production: true,
  appUrl: 'https://managed-event-registry.production.zonarsystems.net/',

  apiBase: {
    url: 'https://api.zonarsystems.net'
  },

  coreEntityApiBase: {
    url: 'https://api.zonarsystems.net/core/v1'
  },

  userPreferencesApiBase: {
    url: 'https://api.zonarsystems.net/alert/v1'
  },

  authEnv: 'production',

  auth: {
    clientID: 'yI6fDqIJOqliptRP5kWXaJ2WRP2fzdXj',
    domain: 'zonar-login.auth0.com',
    audience: 'https://api.zonarsystems.net',
    // These come from the Core APIs as your application is built.
    applicationId: 'b4dc7cc5-ae5a-4b88-ac9e-73bf8de8ee88',
    defaultZonarRole: '420581c5-e099-4528-8e1e-75de394acc90',
    useRefreshTokens: true
  },

  pendo: {
    url: 'https://cdn.pendo.io/agent/static/'
  },

  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '',
    environment: ''
  },

  datadog: {
    applicationId: 'ae864ef9-6e2d-453b-b0ac-999c8219618a',
    clientToken: 'pub8b104aad726d6366de4823da4068593b',
    site: 'us5.datadoghq.com',
    tagEnvironment: 'prod'
  },

  i18n: {
    supportedLanguages: [
      'en',
      'en-US',
      'de-DE',
      'en-GB',
      'it',
      'fr-FR',
      'de',
      'es-ES'
    ],
    defaultLanguage: 'en-US'
  }
};
